$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');

  if (p === 'today_orders') {
    $(document).on('click', '.send-order-email', function () {
      let orderId = $(this).data('order-id');
      $('#emailReceiptModal #order_id').val(orderId);
      $('#emailReceiptModal').modal('show');
    });
  }
});
